import { combineReducers } from 'redux';
import attrs from '../baseHTMLElementStore';
import loader from '../../components/Loader/loaderReducer';
import alert from '../../components/Alert/alertReducer';
import app from '../../components/App/appReducer';
import planning from '../../components/ContentPlanning/contentPlanningReducer';
import view from '../../components/View/viewReducer';
import viewModal from '../../components/ViewModal/viewModalReducer';
import schemaModal from '../../components/SchemaModal/schemaModalReducer';
import form from '../../components/MetadataForm/metadataFormReducer';
import accessControl from '../../components/AccessControl/accessControlReducer';
import administration from '../../components/Administration/administrationReducer';

let reducers = combineReducers({
  app,
  alert,
  administration,
  planning,
  form,
  view,
  viewModal,
  schemaModal,
  accessControl,
  attrs,
  loader
});

export type ContentPlanRootState = ReturnType<typeof reducers>;

export default reducers;
